import styled from "styled-components";

export const Container = styled.div`
  height: 100vh;
  display: grid;
  grid-template-columns: var(--sidebar_width) 1fr;
  grid-template-areas: "sidebar content";
`;

export const Page = styled.div`
  grid-area: content;
  min-width: 0;
  background-color: #f5f5f5;
  display: flex;
  align-items: center;
  justify-content: center;
  padding-top: 5vh;
  padding-bottom: 2vh;
  width: 100%;
  font-family: sans-serif;

  > div {
    min-height: 90vh;
    width: 90%;
    background-color: var(--grey-light);
    box-shadow: #b1a7a6 0px 0px 10px 1px;
    height: 100%;
  }
`;

export const PageContent = styled.div`
  width: 100%;
`;
